import { DefaultProductsType } from "@app/api/product";

import { User } from "@app/types/user";

import styles from "@app/assets/styles/game.module.scss";
import { SkinAssetType } from "@app/api/models/user";

interface ContestUsersLifesProps {
    players: User[];
    characterData: DefaultProductsType;
}

export default function ContestUsersLifes(props: ContestUsersLifesProps) {
   const { players, characterData } = props;

    return (
        <div className={styles.usersLifeContainer}>
            {players.map((user, index) => {
              const characterImg = characterData.characters
                .find((character) => {
                  const id = character.id?.split("-")[0];
                  if (id) return id === user.character;
                })
                ?.products.find(
                  (product) => product.id === user.characterSkinId,
                )
                ?.assets.find((asset) => asset.type === SkinAssetType.Neutral);
                console.log("##### characterImg :", characterImg);

                return (
                    <div key={index} className={styles.userLife}>
                    </div>
                );
            })}
        </div>
    );
}